import * as React from "react"

const Contributors = ()=>{
    return(
        <section></section>
    )
}

export default Contributors